import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dextDateTimeInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map